module.exports = __webpack_public_path__ + "static/profile-d613d3d7c02cc44500162aa185e94a35.png";